import React from 'react'
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import {
  AnimatedText,
  EndIconButton,
  HeroSection,
  HomeSlider,
  Link,
  PromoItem,
  ScreenshotsItem,
  Slash,
} from '../../components'
import { contentfulArrayToObject, getDescription } from '../../utils/cms'
import { useHeroStyles, useStyles } from './Home.styles'
import { SLASH_HEIGHT } from '../../constants'

const IndexPage = ({ t, language, footerNode, data = {}, ...props }) => {
  const { hero, pageSection } = data
  const {
    ContentfulHomepageServices: homepageServices,
    ContentfulSliderBlock: homeSliderBlock,
    ContentfulImageAnimation: {
      href,
      bucketUrl,
      image: {
        file: { url: homePageVideoUrl, contentType },
      },
    },
    ContentfulFeatureSection: featureSection,
  } = contentfulArrayToObject(pageSection)

  const { sliderHeading } = homeSliderBlock || {}
  const {
    ContentfulSectionHeading: { sectionHeadings: beSmartHeading },
  } = contentfulArrayToObject(pageSection)

  // feature section
  const { featureHeading, featureCta } = featureSection
  const featureDescription = getDescription(
    featureSection.featureDescription.raw,
  )
  const screenshotMockups = featureSection.featureImages

  const slashHeight = SLASH_HEIGHT
  const theme = useTheme()
  const newHeight = useMediaQuery(theme.breakpoints.down('sm'))
    ? slashHeight * 0.5
    : slashHeight
  const slashMaxGrowth = (footerNode?.clientHeight * 1.25) / newHeight
  const styles = useStyles()

  return (
    <main className={styles.root}>
      <Slash
        stopGrowingPositionYOffset={footerNode?.clientHeight / 2}
        startGrowingPositionYOffset={footerNode?.clientHeight * 4.5}
        height={newHeight}
        growthScale={{ initial: 1, target: slashMaxGrowth }}
      />
      {hero && (
        <HeroSection homepage t={t} {...hero} useCustomStyles={useHeroStyles} />
      )}
      <Box className={styles.videoContainer}>
        {bucketUrl ? (
          <Link to={href}>
            <img
              className={styles.homeVideo}
              src={bucketUrl}
              alt="Home page image"
            />
          </Link>
        ) : (
          <video
            className={styles.homeVideo}
            loop
            autoPlay={true}
            muted={true}
            playsInline={true}
          >
            <source src={homePageVideoUrl} type={contentType} />
          </video>
        )}
      </Box>
      <Box className={styles.servicesTitle}>
        <AnimatedText isXray variant="h1" content={beSmartHeading} />
      </Box>
      <Container maxWidth="lg">
        {homepageServices.map((homepageService, index) => {
          return (
            <PromoItem
              key={index}
              reverse={!homepageService.imageToRight}
              title={homepageService.serviceHeading}
              description={getDescription(
                homepageService.serviceDescription.raw,
              )}
              animationPath={
                homepageService.serviceImages &&
                homepageService.serviceImages[0].image?.file?.url
              }
              placeholderPath={
                homepageService.serviceImages &&
                (homepageService.serviceImages[0]?.bucketUrl ||
                  homepageService.fallbackUrl)
              }
              cta={homepageService.serviceCta}
            />
          )
        })}
      </Container>
      {homeSliderBlock && sliderHeading && (
        <Box>
          <AnimatedText
            isXray
            variant="h1"
            content={sliderHeading}
            textClass={styles.homeSliderHeading}
          />
          <HomeSlider data={homeSliderBlock} />
        </Box>
      )}

      <Box>
        <Container maxWidth="lg">
          {/* FIXME: rename these to be generic */}
          <Box className={styles.anAccountSection}>
            <AnimatedText
              isXray
              variant="h3"
              textClass={styles.titleScreenShot}
              content={featureHeading}
            />
            <Typography
              className={styles.anAccountSectionDescription}
              variant="body1"
            >
              {featureDescription}
            </Typography>
            {featureCta && (
              <EndIconButton link={featureCta.link} title={featureCta.title} />
            )}
          </Box>
        </Container>
        <ScreenshotsItem allScreenShots={screenshotMockups} />
      </Box>
    </main>
  )
}

export default IndexPage
